import React from 'react';
import Logo from '../../img/terra-logo.webp'; 
import DownloadBtn from './DownloadBtn/DownloadBtn';   
import ButtonNav from './buttonNav/ButtonNav';     
import './Nav.scss';

const Nav = () => {
  
  const navMenuItems = [
    { id: 'wallet-link', label: 'Wallet', href: '#wallet' }, 
    { id: 'sobre-link', label: 'Sobre', href: '#sobre' },
     { id: 'empresa-link', label: 'Cuenta de empresa', href: '#empresa' },
    { id: 'ayuda-link', label: 'Ayuda', href: '#ayuda' }
  ];

  const showDownloadInMobileMenu = true;

  return (
    <div className='container-nav'>
      <nav>
        <img className='img-logo' src={Logo} alt="logo-terra" />

        <ul className="nav-links-desktop">
          {navMenuItems.map(item => (
            <li key={item.id}>
              <a href={item.href}>{item.label}</a>
            </li>
          ))}
        </ul>

        <div className="nav-download-btn-desktop-wrapper">
          <DownloadBtn
            specificClassName="nav-download-btn-desktop"
          />
        </div>

        <div className="nav-mobile-menu-wrapper">
          <ButtonNav
            menuItems={navMenuItems}
            showDownloadBtnInMenu={showDownloadInMobileMenu}
          />
        </div>
      </nav>
    </div>
  );
};

export default Nav;